export const STATEMENT_COLUMN = 'STATEMENT_COLUMN';
export const STATEMENT_INDEX = 'STATEMENT_INDEX';
export const STATEMENT_LOADING_INDEX = 'STATEMENT_LOADING_INDEX';
export const STATEMENT_LOADING_SHOW = 'STATEMENT_LOADING_SHOW';
export const STATEMENT_RESET = 'STATEMENT_RESET';
export const STATEMENT_SEARCH = 'STATEMENT_SEARCH';
export const STATEMENT_SHOW = 'STATEMENT_SHOW';
